'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

// Should take precedence over the cookie
const HEADER_LOCALE_NAME = 'X-NEXT-INTL-LOCALE';

// In a URL like "/en-US/about", the locale segment is "en-US"
const LOCALE_SEGMENT_NAME = 'locale';

exports.HEADER_LOCALE_NAME = HEADER_LOCALE_NAME;
exports.LOCALE_SEGMENT_NAME = LOCALE_SEGMENT_NAME;
